'use strict';
const angular = require('angular');

export class galleriesWidgetComponent {

  constructor(GalleryService) {
    'ngInject';

    this.GalleryService = GalleryService;
  }

  getPreviewText(text) {
    return text ? String(text).replace(/<[^>]+>/gm, ' ').substr(0, 150) + '...' : '';
  }

  $onInit() {
    let METHOD = (this.categories) ? "getNewestByCategories": "getNewest";

    this.GalleryService[METHOD]({count:this.count || 3, categories: this.categories}, data => {
      this.data = data;
    }, err => {
      console.log('could not retrieve newest galleries');
    });
  }
}

export default angular.module('conduuApp.galleriesWidget', [])
  .component('galleriesWidget', {
    template: require('./galleries-widget.component.html'),
    bindings: {
      count: '@',
      categories: '@'
    },
    controller: galleriesWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/galleries-widget/galleries-widget.component.js